import './stars.scss';

import React, { useEffect, useState } from 'react';

import full_star from '@progymedia/sbi-web-occ/src/images/icons/Full_Star.svg';
import half_star from '@progymedia/sbi-web-occ/src/images/icons/Half_Star.svg';
import empty_star from '@progymedia/sbi-web-occ/src/images/icons/Empty_Star.svg';

type StarsProps = {    
    reviewsCount?: number;
    rating: number;
    additionalInfoDisplayLocation?: AdditionalInfoDisplayLocation;
    additionalInfoType: AdditionalInfoType;
    onAdditionalInfoClick?: () => void;
};

export enum AdditionalInfoType {
    AVERAGE = 0,
    NUMBER_OF_REVIEWS = 1,
    STARS_ONLY = 2,
}

export enum AdditionalInfoDisplayLocation {
    LEFT = 0,
    RIGHT = 1
}

export default function Stars(props: StarsProps) {
    const {
        reviewsCount,
        rating,
        additionalInfoDisplayLocation,
        additionalInfoType,
        onAdditionalInfoClick,
    } = props;

    const [stars, setStars] = useState<JSX.Element[]>([]);
    const [additionalInfo, setAdditionalInfo] = useState<string | undefined>(
        undefined
    );

    useEffect(() => {       
        setStars(createStars(rating));
        setAdditionalInfo(getAdditionalInfo(rating));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rating, additionalInfoType]);

    const createStars = (filledStarsNumber: number): JSX.Element[] => {
        let stars: JSX.Element[] = [];

        for (let i = 1; i <= 5; i++) {
            if (filledStarsNumber - i >= 0) {
                stars.push(<img key={`star_${i}`} src={full_star} alt='' />);
            } else if (filledStarsNumber - i === -0.5) {
                stars.push(<img key={`star_${i}`} src={half_star} alt='' />);
            } else {
                stars.push(<img key={`star_${i}`} src={empty_star} alt='' />);
            }
        }

        return stars.map((star) => star);
    };

    const getAdditionalInfo = (
        filledStarsNumber: number
    ): string | undefined => {
        switch (additionalInfoType) {
            case AdditionalInfoType.AVERAGE: {
                return Math.trunc(filledStarsNumber).toString();
            }

            case AdditionalInfoType.NUMBER_OF_REVIEWS: {
                return `(${reviewsCount})`;
            }

            default: {
                return undefined;
            }
        }
    };

    return (
        <div className='stars-container'>
            {additionalInfo && additionalInfoDisplayLocation === AdditionalInfoDisplayLocation.LEFT && (
                <span
                    className={
                        onAdditionalInfoClick
                            ? 'additional-info left clickable'
                            : 'additional-info left'
                    }
                    onClick={onAdditionalInfoClick && onAdditionalInfoClick}
                >
                    {additionalInfo}
                </span>
            )}

            {stars.map((star) => star)}

            {additionalInfo && additionalInfoDisplayLocation === AdditionalInfoDisplayLocation.RIGHT && (
                <span
                    className={
                        onAdditionalInfoClick
                            ? 'additional-info right clickable'
                            : 'additional-info right'
                    }
                    onClick={onAdditionalInfoClick && onAdditionalInfoClick}
                >
                    {additionalInfo}
                </span>
            )}
        </div>
    );
}
